import { render } from "./Comments_OLD.vue?vue&type=template&id=5a1c0978&scoped=true"
import script from "./Comments_OLD.vue?vue&type=script&lang=js"
export * from "./Comments_OLD.vue?vue&type=script&lang=js"

import "./Comments_OLD.vue?vue&type=style&index=0&id=5a1c0978&lang=scss&scoped=true"

import exportComponent from "/Users/emiliedannenberg/Documents/GitHub/nola-paddle-routes/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1c0978"]])

export default __exports__